export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  views: number;
  comments: number;
  isHot: boolean;
  isTop: boolean;
}

export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export interface Testimonial {
  id: string;
  name: string;
  avatar: string;
  content: string;
  platform: string;
  rating: number;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '明星大瓜',
    slug: 'mingxing-dagua',
    description: '娱乐圈明星最新动态、恋情曝光、绯闻八卦一网打尽',
    icon: 'ri-star-line',
    count: 1286,
  },
  {
    id: 'cat-2',
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '网红博主翻车现场实录，人设崩塌全记录',
    icon: 'ri-ghost-line',
    count: 964,
  },
  {
    id: 'cat-3',
    name: '黑料曝光',
    slug: 'heiliao-baoguang',
    description: '独家黑料、内幕消息，让真相浮出水面',
    icon: 'ri-spy-line',
    count: 753,
  },
  {
    id: 'cat-4',
    name: '吃瓜路线',
    slug: 'chigua-luxian',
    description: '吃瓜群众聚集地导航，最新吃瓜入口与路线指引',
    icon: 'ri-road-map-line',
    count: 521,
  },
  {
    id: 'cat-5',
    name: '最新爆料',
    slug: 'zuixin-baoliao',
    description: '24小时新鲜爆料，吃瓜群众一手消息源',
    icon: 'ri-flashlight-line',
    count: 1892,
  },
];

export const articles: Article[] = [
  {
    id: 'art-1',
    slug: 'dingliu-nanyixing-paiwai-chugui-baoliao',
    title: '顶流男星被曝片场耍大牌，知情人透露更多惊人内幕',
    excerpt: '近日有媒体爆料某顶流男星在拍摄现场多次耍大牌，不仅迟到早退，还对工作人员恶语相向。多位业内人士证实该消息，引发网友热议。',
    content: `<p>近日，娱乐圈再掀波澜。据多位知情人士向本平台独家爆料，某当红顶流男星在最新剧组拍摄期间多次出现不专业行为。</p><p>据现场工作人员透露，该男星在为期三个月的拍摄周期内，迟到次数高达二十余次，最严重一次让全组等待超过四个小时。不仅如此，该男星还因个人情绪问题多次对化妆师、场务等基层工作人员恶语相向。</p><p>"有一次因为发胶味道不对，他直接把化妆台上的东西全扫到地上，然后说'你们是不是不想干了'，"一位不愿透露姓名的现场工作人员告诉记者。</p><p>更令人震惊的是，该男星还被指在拍摄期间频繁使用替身，自己则在房车里直播打游戏。有网友扒出其直播记录，确实与拍摄时间高度重合。</p><p>目前该男星方面尚未对此事做出回应。但已有多个品牌方在社交媒体上撤下了与该男星相关的宣传内容。业内人士分析，如果这些爆料属实，该男星可能面临高额违约金赔偿。</p><p>吃瓜群将持续关注此事进展，为各位吃瓜群众带来第一手消息。</p>`,
    category: '明星大瓜',
    categorySlug: 'mingxing-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20dramatic%20scene%20with%20movie%20set%20background%2C%20warm%20lighting%2C%20cinematic%20composition%2C%20mysterious%20atmosphere%2C%20film%20crew%20equipment%20silhouette%2C%20dark%20and%20dramatic%20mood%2C%20editorial%20photography%20style%2C%20rich%20contrast%2C%20professional%20lighting%20setup&width=800&height=450&seq=chigua-art-1&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-06',
    tags: ['顶流男星', '耍大牌', '片场内幕', '品牌解约'],
    views: 128500,
    comments: 3621,
    isHot: true,
    isTop: true,
  },
  {
    id: 'art-2',
    slug: 'zhiming-nvwanghong-zhibo-fanche-xianchang',
    title: '百万粉女网红直播翻车！带货产品被扒是三无产品',
    excerpt: '拥有三百万粉丝的美妆女网红在直播间带货时被网友当场揭穿，所售护肤品竟是三无产品。直播回放视频在全网疯传，品牌方紧急发声明切割。',
    content: `<p>昨晚，一场原本应该普通的带货直播，却演变成了一场史诗级翻车现场。</p><p>拥有320万粉丝的美妆网红"甜心小鹿"在直播间推出一款号称"韩国原装进口"的高端精华液，售价398元。然而直播进行到半小时时，有眼尖的网友发现产品包装上的韩文存在明显语法错误。</p><p>随后更多网友加入"扒皮"行动：产品包装上的生产批号在国家药监局官网查无此号，所谓的韩国生产商在韩国工商系统中根本不存在，甚至连产品成分表都出现前后矛盾的情况。</p><p>面对弹幕中不断刷屏的质疑，"甜心小鹿"先是辩解"渠道绝对正规"，随后在工作人员提醒下匆匆下播。但为时已晚，直播回放已经被网友录屏并在各大平台疯传。</p><p>更戏剧性的是，该网红此前一直以"成分党""严格选品"人设吸引粉丝，多次在视频中强调"我只推荐自己用过且真的好用的产品"。这次翻车让人设彻底崩塌。</p><p>目前，"甜心小鹿"的账号评论区已被愤怒的粉丝攻陷，大量已购买产品的消费者要求退货退款。市场监管部门也已关注到此事。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20female%20influencer%20livestreaming%20setup%20with%20beauty%20products%20on%20table%2C%20ring%20light%20glowing%2C%20dramatic%20lighting%2C%20modern%20studio%20background%2C%20warm%20pink%20and%20gold%20tones%2C%20editorial%20product%20photography%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=450&seq=chigua-art-2&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-05',
    tags: ['网红翻车', '直播带货', '三无产品', '人设崩塌'],
    views: 256800,
    comments: 7823,
    isHot: true,
    isTop: false,
  },
  {
    id: 'art-3',
    slug: 'yulequan-ziben-baoliao-neimu-jingren',
    title: '娱乐圈资本局曝光！某娱乐公司涉嫌阴阳合同被调查',
    excerpt: '独家消息：某大型娱乐经纪公司因涉嫌利用阴阳合同偷逃税款被有关部门立案调查。涉及多位知名艺人，金额或达数亿元。',
    content: `<p>本平台从接近调查的消息人士处独家获悉，某总部位于北京的头部娱乐经纪公司近日因涉嫌利用阴阳合同偷逃税款，已被税务和公安部门联合立案调查。</p><p>据了解，该公司旗下签约艺人超过五十位，其中包括多位一线明星和顶流偶像。调查人员在对该公司近五年的财务记录进行审查时，发现了大量可疑的合同和资金往来记录。</p><p>消息人士透露，该公司惯用的操作手法是：与艺人签订一份"阳合同"向税务机关报备，约定较低的片酬或出场费；同时私下签订一份"阴合同"，约定真实的报酬金额。差额部分通过境外公司账户或现金方式支付，以此逃避高额个人所得税。</p><p>初步调查显示，仅过去三年，通过这种方式隐匿的艺人收入就可能高达数亿元人民币，涉及偷逃税款金额巨大。</p><p>业内人士表示，如果调查结果属实，不仅该公司将面临巨额罚款和相关责任人被追究刑事责任，旗下涉及此事的艺人也可能面临补缴税款、罚款以及公众形象受损等多重打击。</p><p>目前已有多个品牌暂停了与该公司艺人的合作洽谈。吃瓜群将密切关注案件进展。</p>`,
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    coverImage: 'https://readdy.ai/api/search-image?query=Serious%20business%20investigation%20scene%20with%20documents%20and%20contracts%20on%20dark%20wooden%20desk%2C%20dramatic%20lighting%20from%20window%2C%20mysterious%20atmosphere%2C%20gold%20pen%20and%20stamp%2C%20office%20background%20blurred%2C%20cinematic%20photography%2C%20warm%20dark%20tones&width=800&height=450&seq=chigua-art-3&orientation=landscape',
    author: '吃瓜深度调查',
    publishDate: '2026-07-04',
    tags: ['阴阳合同', '偷税漏税', '经纪公司', '调查'],
    views: 389200,
    comments: 12456,
    isHot: true,
    isTop: false,
  },
  {
    id: 'art-4',
    slug: 'qq-chiguaqun-zuixin-rukou-2026',
    title: '2026年最新QQ吃瓜群号汇总！吃瓜群众聚集地入口更新',
    excerpt: '吃瓜群官网最新整理的QQ吃瓜群号大全，包含明星八卦群、网红爆料群、娱乐资讯群等多个分类。群内活跃度超高，吃瓜第一手消息都在这里。',
    content: `<p>各位吃瓜群众注意啦！吃瓜群官网为大家整理了2026年7月最新有效的QQ吃瓜群号，欢迎大家加入一起快乐吃瓜！</p><h3>明星八卦专区</h3><p>吃瓜群①群（明星大瓜）：9382****（已满）</p><p>吃瓜群②群（明星大瓜）：7256****</p><p>吃瓜群③群（影视综艺）：4819****</p><h3>网红爆料专区</h3><p>吃瓜群众聚集地①群：6593****</p><p>网红塌房前线群：2074****</p><h3>综合吃瓜专区</h3><p>吃瓜群总群：1847****（每日清理不活跃成员）</p><p>吃瓜群众路线群：5309****</p><p>温馨提示：加群请备注"吃瓜群官网"，群内禁止广告、禁止引战、禁止人身攻击。请大家文明吃瓜，理性讨论！</p>`,
    category: '吃瓜路线',
    categorySlug: 'chigua-luxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20social%20media%20chat%20group%20concept%2C%20multiple%20speech%20bubbles%20floating%2C%20warm%20vibrant%20colors%2C%20digital%20community%20connection%20visual%2C%20clean%20minimal%20design%2C%20soft%20pastel%20gradient%20background%2C%20friendly%20and%20inviting%20atmosphere%2C%20modern%20UI%20style&width=800&height=450&seq=chigua-art-4&orientation=landscape',
    author: '吃瓜群管理员',
    publishDate: '2026-07-03',
    tags: ['QQ吃瓜群', '群号汇总', '吃瓜群众聚集地', '吃瓜群入口'],
    views: 562100,
    comments: 8932,
    isHot: true,
    isTop: true,
  },
  {
    id: 'art-5',
    slug: 'NV-tuanti-chengyuan-neihong-jiekai-zhenxiang',
    title: '当红女团成员被曝队内不和，综艺现场冷脸互怼画面曝光',
    excerpt: '某当红女团两位成员在综艺录制现场疑似发生激烈争执，冷脸互怼画面被现场观众拍下并在网上疯传。粉丝群体随之分裂对峙。',
    content: `<p>近日，一则某当红女团综艺录制现场的偷拍视频在网络上引发轩然大波。</p><p>视频中可以看到，该女团的两位核心成员在游戏环节中出现了明显的摩擦。其中一位成员在输掉游戏后，对另一位成员说了几句话后便转身离开，表情明显不悦。而被说的那位成员则当场黑了脸，后续录制过程中两人全程零交流。</p><p>据悉，这并非两人第一次被传不和。早在去年的一次颁奖典礼上，就有粉丝发现两人在后台刻意保持距离。而在社交媒体上，两人也很少互动，与其他成员之间的亲密互动形成鲜明对比。</p><p>有知情人士透露，两人不和的主要原因是资源分配问题。"公司明显更捧A（化名），给了她两个大牌代言和一部女主剧，但B（化名）无论是唱功还是舞蹈都更出色，粉丝量也更多，自然心里不平衡。"</p><p>视频曝光后，两家的粉丝也在网上展开了激烈的"对战"，互相指责对方偶像"耍大牌""心机重"。话题一度冲上热搜榜首。</p>`,
    category: '明星大瓜',
    categorySlug: 'mingxing-dagua',
    coverImage: 'https://readdy.ai/api/search-image?query=Girl%20group%20performing%20on%20stage%20with%20dramatic%20lighting%2C%20tension%20between%20two%20members%2C%20K-pop%20style%20costumes%2C%20colorful%20stage%20lights%2C%20emotional%20intensity%2C%20professional%20concert%20photography%2C%20dynamic%20composition%2C%20warm%20and%20cool%20lighting%20contrast&width=800&height=450&seq=chigua-art-5&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-07-02',
    tags: ['女团', '队内不和', '综艺翻车', '粉丝互撕'],
    views: 198300,
    comments: 5421,
    isHot: false,
    isTop: false,
  },
  {
    id: 'art-6',
    slug: 'dianying-quan-qian-guize-jingren-neimu',
    title: '电影圈潜规则大揭秘：选角导演自曝收受回扣内幕',
    excerpt: '一位在电影圈从业十余年的选角导演匿名接受专访，揭露了影视行业选角过程中的潜规则和利益输送链条。',
    content: `<p>影视行业的选角环节一直笼罩着一层神秘的面纱。近日，一位在电影圈从业超过十五年的资深选角导演（化名老王）接受了本平台的匿名专访，揭开了这个行业不为人知的一面。</p><p>"很多人以为演员能不能拿到角色靠的是演技和形象，但实际上背后的利益输送远比大家想象的复杂，"老王开门见山地说。</p><p>据老王透露，在一些中大型制作中，主要角色的选角往往不是导演一人说了算，投资方、制片人、经纪公司甚至某些"有背景"的个人都会参与其中。选角过程中的回扣比例通常在片酬的10%到30%之间。</p><p>"举个例子，一个配角片酬50万，选角导演可能拿到5万到15万的回扣。有些经纪公司为了推自家艺人，甚至愿意倒贴钱。"</p><p>老王还透露，一些所谓的"带资进组"现象在行业内十分普遍。"有的演员演技确实不行，但他背后的投资方能给剧组带来几千万的投资，这种情况下导演也只能妥协。"</p>`,
    category: '黑料曝光',
    categorySlug: 'heiliao-baoguang',
    coverImage: 'https://readdy.ai/api/search-image?query=Film%20casting%20audition%20room%20with%20camera%20and%20spotlight%2C%20behind%20the%20scenes%20movie%20production%2C%20dramatic%20shadow%20play%2C%20director%20chair%20silhouette%2C%20warm%20cinematic%20lighting%2C%20mysterious%20atmosphere%2C%20professional%20film%20set%20photography&width=800&height=450&seq=chigua-art-6&orientation=landscape',
    author: '吃瓜深度调查',
    publishDate: '2026-07-01',
    tags: ['电影圈', '潜规则', '选角', '回扣'],
    views: 145600,
    comments: 3210,
    isHot: false,
    isTop: false,
  },
  {
    id: 'art-7',
    slug: 'daxing-wanghong-zhibo-jian-qishi-jian',
    title: '某大胃王吃播博主被曝假吃催吐，年收入千万背后的真相',
    excerpt: '坐拥千万粉丝的大胃王吃播博主近日被前团队成员爆料：视频中的"大吃大喝"全是假象，实际拍摄后立即催吐。',
    content: `<p>吃播行业再曝惊人黑幕。一位曾在某千万粉丝级大胃王吃播博主团队工作过的前员工，近日向本平台提供了一系列令人震惊的爆料。</p><p>据该前员工透露，这位在镜头前看起来能轻松吞下十人份食物的吃播博主，实际上每次拍摄都在"演戏"。"拍摄时会用广角镜头让食物看起来更多，吃的时候用的都是特制的'假食物'——比如看起来像炸鸡实际上是豆腐做的，看起来像红烧肉实际上是魔芋。"</p><p>更令人震惊的是，即使是这样，博主在拍摄结束后也会立即到专门准备的房间进行催吐。"团队里有专人负责准备催吐工具和漱口水，这已经是公开的秘密了。"</p><p>这位博主每年的广告收入和直播打赏合计超过千万元。前员工表示："他对外宣传的'天生吃不胖体质'完全是骗人的，真实情况是长期催吐已经导致了严重的胃病和牙齿腐蚀。"</p><p>目前该博主尚未对此事做出回应，但其最新视频的评论区已被大量质疑声淹没。</p>`,
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    coverImage: 'https://readdy.ai/api/search-image?query=Luxurious%20food%20spread%20on%20large%20dining%20table%2C%20mukbang%20style%20setup%20with%20camera%20and%20lighting%20equipment%2C%20abundant%20Chinese%20dishes%2C%20warm%20appetizing%20colors%2C%20professional%20food%20photography%20setup%2C%20behind%20the%20scenes%20feel%2C%20rich%20textures%20and%20details&width=800&height=450&seq=chigua-art-7&orientation=landscape',
    author: '吃瓜前线记者',
    publishDate: '2026-06-30',
    tags: ['吃播', '假吃', '催吐', '千万收入'],
    views: 321400,
    comments: 9876,
    isHot: true,
    isTop: false,
  },
  {
    id: 'art-8',
    slug: 'chiguaqun-app-zuixin-xiazai-dizhi',
    title: '吃瓜群APP最新下载地址发布！随时随地快乐吃瓜',
    excerpt: '吃瓜群官方APP最新版本已上线！支持iOS和Android双平台，界面全新升级，推送更及时，让你不错过任何一条大瓜。',
    content: `<p>各位吃瓜群众期待已久的吃瓜群官方APP终于迎来重大更新！</p><h3>新版本亮点</h3><p>1. 全新UI设计：界面更加简洁美观，浏览体验大幅提升</p><p>2. 实时推送：大瓜发生第一时间推送通知，让你永远快人一步</p><p>3. 爆料投稿：一键投稿功能，你的爆料也可能成为头条</p><p>4. 吃瓜社区：和千万吃瓜群众一起讨论，弹幕互动超有趣</p><p>5. 夜间模式：深夜吃瓜不伤眼，暗黑模式护眼又酷炫</p><h3>下载方式</h3><p>iOS用户：App Store搜索"吃瓜群"即可下载</p><p>Android用户：在官网扫描二维码或点击下载链接获取APK安装包</p><p>温馨提示：请认准吃瓜群官方渠道下载，谨防山寨APP！</p>`,
    category: '吃瓜路线',
    categorySlug: 'chigua-luxian',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20news%20app%20interface%2C%20clean%20minimal%20design%2C%20warm%20background%20with%20soft%20gradient%2C%20mobile%20app%20mockup%20on%20wooden%20desk%2C%20coffee%20cup%20beside%2C%20lifestyle%20photography%2C%20natural%20morning%20light%2C%20cozy%20atmosphere&width=800&height=450&seq=chigua-art-8&orientation=landscape',
    author: '吃瓜群管理员',
    publishDate: '2026-06-28',
    tags: ['吃瓜群APP', '下载地址', '最新版本'],
    views: 456200,
    comments: 5678,
    isHot: false,
    isTop: false,
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '吃瓜达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20warm%20lighting%2C%20clean%20background%2C%20professional%20headshot%2C%20natural%20expression%2C%20soft%20bokeh%20background&width=200&height=200&seq=testimonial-avatar-1&orientation=squarish',
    content: '自从发现了吃瓜群，我就再也没有错过任何一条大瓜！推送速度真的太快了，比我朋友圈的消息还灵通。每天打开吃瓜群已经成了我的习惯！',
    platform: '微博',
    rating: 5,
  },
  {
    id: 't-2',
    name: '资深八卦爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20modern%20casual%20style%2C%20warm%20genuine%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20photography%2C%20natural%20daylight%2C%20friendly%20atmosphere&width=200&height=200&seq=testimonial-avatar-2&orientation=squarish',
    content: '吃瓜群的爆料质量真的高！很多独家消息都是别的地方看不到的。而且分类很清楚，想看明星八卦还是网红翻车，一键就能找到。强烈推荐给所有爱吃瓜的朋友！',
    platform: '小红书',
    rating: 5,
  },
  {
    id: 't-3',
    name: '瓜田里的守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20portrait%2C%20trendy%20casual%20outfit%2C%20confident%20expression%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%2C%20natural%20pose&width=200&height=200&seq=testimonial-avatar-3&orientation=squarish',
    content: '作为一个吃瓜五年的老用户，我可以负责任地说，吃瓜群是目前最好用的吃瓜平台。信息更新快、内容丰富、社区氛围好，瓜友们都特别有才，评论比正文还精彩！',
    platform: '豆瓣',
    rating: 5,
  },
];

export const stats = {
  totalArticles: 15280,
  dailyVisitors: 680000,
  registeredUsers: 3200000,
  totalComments: 89000000,
};